import store from "../store";
import address from "./address";
import localStorageFunc from "./localStorageFunc";
import { keyMapsMutation, keyMapsAction } from './storeKeys';
import Utility from "./utility";

const updateHeaders = (headers, payload) => {
    return {
        ...headers,
        userId: payload?.userData?.userId || '',
        source: 'googlepay',
        cartId: payload?.userData?.cartId || ''
    }
};

const loginSuccess = (payload) => {
   store.commit(keyMapsMutation.UPDATE_LOCALSTORAGE_USERINFO, payload.credentials);
   store.commit(keyMapsMutation.UPDATE_LOGGIN_STATE, payload.userData);
   let userInfo = localStorageFunc.getUserData();
   if(userInfo?.headers) {
    let headers = updateHeaders(userInfo.headers, payload);
    userInfo = {
        ...payload,
        headers
    }
    localStorageFunc.setUserData(userInfo);
   }
   const prevAddress = localStorageFunc.getAddressDetail() || {};
   if(prevAddress && typeof(prevAddress) === "string"){
    prevAddress = Utility.decryptData(prevAddress);
   }

   const prevAddressObj = typeof prevAddress === 'string' ? JSON.parse(prevAddress) : prevAddress;
   const userData = payload?.userData || {};
   const addressForm = {
    fName: userData?.firstName || '',
    lName: userData?.lastName || '',
    mobNo: userData?.mobile || '',
    email: userData?.email || '',
    address: prevAddressObj?.address || '',
    houseNo: prevAddressObj?.houseNo || '',
  };
  let encryptedData = Utility.encryptData(addressForm);  
  localStorageFunc.setAddressDetail(encryptedData);
//   localStorageFunc.setPaymentModeAvailable('');
  localStorageFunc.setWalletSelected('');
  localStorageFunc.setTotalWalletBalance('');
  address.getSavedAddress(userData);
  location.reload();
};

export default loginSuccess;
